<template>
  <div v-if="loading">
    <div class="row">
      <div class="col-12">
        <label class="font28 font500">
          <i class="fas fa-history fa-13"></i> ประวัติการส่งข้อความ
        </label>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 py-1 px-2">
        <router-link to="/Messagereport">
          <button
            type="button"
            class="btn btn-cancel color_white font12"
            style="font-weight:400;"
          >
            <i class="fas fa-angle-double-left"></i> ย้อนกลับ
          </button>
        </router-link>
        {{ this.data.rows[0].msg }}
      </div>
    </div>
    <div class="row">
      <div class="align-self-center ml-3 pt-2">สถานะข้อความ</div>
      <div class="col-12 col-md-3 px-2 pt-2">
        <select class="browser-default custom-select" v-model="search.status">
          <option selected>ทั้งหมด</option>
          <option value="1">ยังไม่ได้ส่ง</option>
          <option value="2">กำลังส่ง</option>
          <option value="3">ส่งเรียบร้อย</option>
          <option value="3">ยกเลิก</option>
        </select>
      </div>
      <div class="align-self-center ml-3 pt-2">เลือกสถานะ DR</div>
      <div class="col-12 col-md-3 px-2 pt-2">
        <select
          class="browser-default custom-select"
          v-model="search.status_dr"
        >
          <option selected>ทั้งหมด</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="3">4</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="align-self-center ml-3 pt-1">เลือกการค้นหา</div>
      <div class="col-12 col-md-2 p-2">
        <select class="browser-default custom-select" v-model="search.type">
          <option value="1">หมายเลขโทรศัพท์</option>
          <option value="2">เวลาส่ง</option>
          <option value="3">Status Code</option>
          <option value="4">สถานะ DR</option>
        </select>
      </div>
      <div class="col-12 col-md-3 p-2">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon">
              <mdb-icon far icon="edit" />
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            aria-describedby="basic-addon"
            width="80%"
            v-model="search.text"
          />
        </div>
      </div>
      <div class="col-12 col-md-5 py-1">
        <button
          type="button"
          class="btn btn-search color_white font12 mr-1"
          style="font-weight:400; margin-left:-8px;"
          @click="Searchfilter()"
        >
          <i class="fab fa-sistrix"></i> Search
        </button>
        <download-excel
          class="btn btn-exel color_white font12"
          :data="json_data"
          :fields="json_fields"
          worksheet="My Worksheet"
          name="fileport_excel.xls"
          style="font-weight:400;"
          >Excel</download-excel
        >
        <download-excel
          class="btn btn-txt color_white font12 ml-1"
          :data="json_data"
          :fields="json_fields"
          worksheet="My Worksheet"
          name="fileport_csv.txt"
          style="font-weight:400; margin-right:12px;"
          type="csv"
          >txt</download-excel
        >
        <button
          type="button"
          class="btn btn-cancel color_white font12"
          style="font-weight:400; margin-left:-8px;"
        >
          <i class="fas fa-times"></i> Cancel
        </button>
      </div>
    </div>
    <div>
      <mdb-datatable
        :arrows="true"
        :data="data"
        striped
        bordered
        :searching="false"
        scrollY
        maxHeight="450px"
      />
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
// let no = 0;
export default {
  name: "Takeoutreport",
  data() {
    return {
      loading: false,
      searchTxt: "",
      data: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
            format: (value) => {
              return value;
            },
          },
          {
            label: "สถานะ",
            field: "send_status",
            sort: true,
            format: (value) => {
              let data = "";
              if (value === "OK")
              {
                data =
                  "<span class='btn-status-green text-white font13 px-3'>ส่งเรียบร้อย</span>";
                return data;
              } else {
                data =
                  "<span class='btn-status-red text-white font13 px-3'>ยังไม่ได้ส่ง</span>";
                return data;
              }
            },
          },
          {
            label: "หมายเลขโทรศัพท์",
            field: "phone",
            sort: true,
          },
          {
            label: "วันที่ส่ง",
            field: "date",
            sort: true,
            format: (value) => {
              if (value != "0000-00-00 00:00:00") {
                return moment(value).format("DD/MM/YYYY HH:mm:ss");
              } else {
                return "-";
              }
            },
          },
          {
            label: "StatusCode",
            field: "send_status",
            sort: true,
            format: (value) => {
              if (value != "") {
                return value;
              } else {
                return "<b>await send</b>";
              }
            },
          },
          {
            label: "สถานะ DR",
            field: "dr_status",
            format: (value) => {
              if (value === "Success") {
                return "สำเร็จ";
              } else if (value === "Expired") {
                return "เบอร์นี้ติดต่อไม่ได้ เช่น ปิดเครื่อง";
              } else if (value === "Fail") {
                return "เบอร์ปิดบริการ";
              } else if (value === "Blocklist") {
                return "แจ้งไม่รับ sms";
              } else {
                return "รอผลการส่ง";
              }
              //   if (value == "-") {
              //     return "N";
              //   } else {
              //     return value;
              //   }
            },
            sort: true,
          },
        ],
        rows: null,
      },
      json_fields: {
        สถานะ: "send_status",
        หมายเลขโทรศัพท์: "phone",
        วันที่ส่ง: "date",
        สถานะ_DR: "dr_status",
      },
      json_data: [],
      search: {
        date: null,
        page: "1",
        status: null,
        status_dr: null,
        status_code: null,
        type: null,
        text: null,
        action: "Search",
      },
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      token: "token",
    }),
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    async Searchfilter() {
      await this.callApiMotherFucker({
        method: "post",
        path: "/report_detail",
        data: this.search,
      }).then((res) => {
        this.loading = true;
        if (res) {
          this.data.rows = this.$add_index(res);
          //  this.json_data = res;
        }
      });
    },
    async Cancelfilter() {
      this.search = {
        date: null,
        page: "1",
        status: null,
        status_dr: null,
        status_code: null,
        type: null,
        text: null,
        action: "Search",
      };
      await this.callApiMotherFucker({
        method: "post",
        path: "/detail_message",
        data: { id: this.$route.query.see },
      }).then((res) => {
        this.loading = true;
        if (res) {
          this.data.rows = this.$add_index(res);
          this.json_data = res;
        }
      });
    },
  },
  async mounted() {
    this.loading = true;
   let goto = this;
    await this.callApiMotherFucker({
      method: "post",
      path: "/detail_message",
      data: { id: this.$route.query.see, date: this.$route.query.date },
    }).then((res) => {
      this.loading = true;
      if ( res.code != 1) {
        this.data.rows = this.$add_index(res);
        this.json_data = res;
      } else {
        this.$swal
          .fire({
            icon: "error",
            html: res.msg,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
             goto.$router.push("/Messagereport");
            }
          });
      }
    });
  },
};
</script>
<style scoped>
.fa-13 {
  font-size: 1em;
}
.field-icon {
  margin-left: 25px;
  margin-right: 10px;
  margin-top: 0px;
  position: relative;
  z-index: 2;
}
.border-detail {
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px;
}
.hr-horizontal {
  border: 1px solid #cccccc;
  margin-right: -15px;
  margin-left: -15px;
}
.btn-status-green2 {
  background: #27ae60;
  border-radius: 3px;
  padding: 3px 9px 3px 9px;
  font-size: 12px;
  width: 80px;
}
.btn-status-yellow2 {
  background: #f2c94c;
  border-radius: 3px;
  padding: 3px 9px 3px 9px;
  font-size: 12px;
  width: 80px;
}
.btn-status-gray2 {
  background: #828282;
  border-radius: 3px;
  padding: 3px 9px 3px 9px;
  font-size: 12px;
  width: 80px;
}
</style>
